<template>
  <Modal v-model="visible" width="400px" :footer-hide="true" :mask-closable="false" class="my-modal">
    <Form ref="form" :model="formParams" class="page-form less" v-if="visible" label-position="top">
      <FormItem prop="date" label="请选择需要启动计算的继续率月份" class="full" :rules="$units.formRule.required('请选择', 'change', 'date')">
        <DatePicker transfer format="yyyy-MM" type="month" :options="options" v-model="formParams.date" @on-change="datePick" placeholder="请选择">
        </DatePicker>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="submit" :loading="loading">提交</Button>
    </div>
  </Modal>
</template>

<script>
import dayjs from 'dayjs';
export default {
  mixins: [],
  components: {},
  props: ['searchParams'],
  data() {
    return {
      // 归属类型映射表
      owerMap: {
        '1': '保险公司',
        '2': '通道公司',
        '3': '机构',
        '4': '渠道'
      },
      // 弹窗类型
      type: '',
      // 弹窗显示状态
      visible: false,
      // 提交按钮加载状态
      loading: false,
      // 接口权限码
      apiPermissionCode: '',
      // 日期选择器配置
      options: {
        // 禁用大于当前日期的日期
        disabledDate(date) {
          return dayjs(date).isAfter(dayjs());
        }
      },
      // 表单参数
      formParams: {
        owerId: [], // 归属ID列表
        date: ''    // 选择的月份
      } // 查询保司、通道、机构列表
    };
  },
  watch: {
    searchParams: {
      handler(newVal) {
        if (newVal) {
          this.formParams = { ...newVal, owerId: [] };
        } else {
          this.formParams = { owerId: [], date: '' };
        }
      },
      deep: true,
      immediate: true
    },
    visible(newVal) {
      if (!newVal) {
        this.$refs.form.resetFields();
      }
    }
  },
  created() { },
  methods: {
    datePick(res) {
      // 重置归属ID和名称
      this.formParams.owerId = [];
      this.formParams.name = '';
      if (res) {
        const [year, month] = res.split('-');
        this.formParams.year = year;
        this.formParams.month = month;
        this.formParams.date = new Date(res);
        this.getCompanyList(); // 获取保司列表
      } else {
        this.formParams.year = '';
        this.formParams.month = '';
        this.formParams.date = '';
      }
    },
    open(type, isAgain, apiPermissionCode) {
      this.apiPermissionCode = apiPermissionCode;
      this.formParams.isAgain = isAgain;
      this.visible = true;
      this.type = type;
    },
    async submit() {
      try {
        // 校验表单
        const isValid = await this.$refs.form.validate();
        if (!isValid) return;

        await this.$notice.inquiry('是否开始计算？');

        const { owerType, owerId, year, month } = this.formParams;
        const formParams = {
          owerType,
          owerIds: owerId,
          year,
          month,
        };

        this.loading = true;
        await this.$http({
          type: 'POST',
          url: '/buz/continuityRateRecord/startCalculation',
          data: formParams,
          apiPermissionCode: this.apiPermissionCode
        });

        this.$notice.success('正在计算继续率，请3分钟之后刷新页面查看结果');
        this.visible = false;
        this.$emit('success');
      } catch (e) {
        // 可根据需要添加错误提示
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.my-modal {
  /deep/ {
    .ivu-checkbox-inner {
      top: -1px;
    }

    .ivu-checkbox-group-item {
      width: 25%;
      margin-right: 0;
    }
  }
}

.tab-box {
  position: relative;
  margin-bottom: 10px;

  .tab-name {
    position: absolute;
    left: 0;
    top: 11px;
    z-index: 1;
    font-size: 14px;
    font-weight: bold;
  }

  /deep/ {
    .ivu-tabs-nav {
      padding-left: 120px;
    }
  }
}
</style>
